_N_E =
(window["webpackJsonp_N_E"] = window["webpackJsonp_N_E"] || []).push([[37],{

/***/ "FYf8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* reexport */ main_Image; });
__webpack_require__.d(__webpack_exports__, "b", function() { return /* reexport */ imgix_createUrl; });

// UNUSED EXPORTS: butterUrlFormatter, storyblokUrlFormatter, calculateRatio, Ratio

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/slicedToArray.js + 3 modules
var slicedToArray = __webpack_require__("ODXe");

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__("q1tI");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// CONCATENATED MODULE: ./node_modules/@soundboks/elements-image/main/useMediaInfo.tsx
var __jsx = react_default.a.createElement;

/* eslint-disable unicorn/filename-case */


var getWindowDimensions = function getWindowDimensions() {
  var _document$documentEle = document.documentElement,
      clientWidth = _document$documentEle.clientWidth,
      clientHeight = _document$documentEle.clientHeight;
  return "Window Dimension ".concat(clientWidth, "px \u2715 ").concat(clientHeight, "px");
};

function useMediaInfo(visible) {
  var _useState = Object(react["useState"])(""),
      imageLocation = _useState[0],
      setImageLocation = _useState[1];

  var _useState2 = Object(react["useState"])(""),
      windowDimensions = _useState2[0],
      setWindowDimensions = _useState2[1];

  Object(react["useEffect"])(function () {
    var handleResize = function handleResize() {
      return setWindowDimensions(getWindowDimensions());
    };

    window.addEventListener("resize", function () {
      return handleResize;
    });
    handleResize();
    return function () {
      return window.removeEventListener("resize", handleResize);
    };
  }, []);

  if (visible === false) {
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    return [function () {}, function () {
      return null;
    }, {}];
  }

  var backgroundGrid = {
    backgroundColor: "#269",
    backgroundImage: "linear-gradient(rgba(255,255,255,.5) 2px, transparent 2px), linear-gradient(90deg, rgba(255,255,255,.5) 2px, transparent 2px), linear-gradient(rgba(255,255,255,.28) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,.28) 1px, transparent 1px)",
    backgroundSize: "100px 100px, 100px 100px, 20px 20px, 20px 20px",
    backgroundPosition: "-2px -2px, -2px -2px, -1px -1px, -1px -1px"
  };

  var sourceTracker = function sourceTracker(event) {
    setImageLocation(event.target.currentSrc);
  };

  var displayInfo = function displayInfo() {
    return /*#__PURE__*/react_default.a.createElement(react_default.a.Fragment, null, /*#__PURE__*/react_default.a.createElement("div", {
      // eslint-disable-next-line react-native/no-inline-styles
      style: {
        position: "absolute",
        top: 0,
        left: 0,
        padding: "2px 4px",
        backgroundColor: "rgba(255, 255, 255, 0.7)",
        font: "small monospace"
      }
    }, windowDimensions), /*#__PURE__*/react_default.a.createElement("div", {
      // eslint-disable-next-line react-native/no-inline-styles
      style: {
        position: "absolute",
        bottom: 0,
        left: 0,
        padding: "2px 4px",
        backgroundColor: "rgba(255, 255, 255, 0.7)",
        font: "small monospace"
      }
    }, imageLocation));
  };

  return [sourceTracker, displayInfo, backgroundGrid];
}
// CONCATENATED MODULE: ./node_modules/@soundboks/elements-image/main/common.ts
function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var MediaConditions;

(function (MediaConditions) {
  MediaConditions["Phone"] = "(max-width: 599px)";
  MediaConditions["TabletPortrait"] = "(min-width: 600px)";
  MediaConditions["TabletLandscape"] = "(min-width: 900px)";
  MediaConditions["Desktop"] = "(min-width: 1200px)";
  MediaConditions["BigDesktop"] = "(min-width: 1800px)";
})(MediaConditions || (MediaConditions = {}));

var Ratio;

(function (Ratio) {
  Ratio[Ratio["Square"] = 1] = "Square";
  Ratio[Ratio["FourToThree"] = 0.75] = "FourToThree";
  Ratio[Ratio["ThreeToFour"] = 1.3333333333333333] = "ThreeToFour";
})(Ratio || (Ratio = {}));

var calculateRatio = function calculateRatio(value, ratio) {
  return value * ratio;
};
var isNum = function isNum(value) {
  return typeof value === "number" && !Number.isNaN(value);
};
var withCreateDensityUrlSet = function withCreateDensityUrlSet(createUrl, path, options) {
  var _ref = options || {},
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? 0 : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? 0 : _ref$height,
      _ref$density = _ref.density,
      density = _ref$density === void 0 ? [] : _ref$density;

  var densities = !Array.isArray(density) ? [density] : density;
  var sourceList = [];
  sourceList.push(createUrl(path, {
    width: width,
    height: height
  }));

  var _iterator = _createForOfIteratorHelper(densities),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var value = _step.value;

      if (value > 1) {
        var url = createUrl(path, {
          width: isNum(width) ? width * value : 0,
          height: isNum(height) ? height * value : 0
        });
        sourceList.push("".concat(url, " ").concat(value, "x"));
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  return sourceList.join(", ");
};
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("rePB");

// CONCATENATED MODULE: ./node_modules/@soundboks/elements-image/main/styles.ts


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var createFrameStyles = function createFrameStyles(width, height, maxWidth, maxHeight, backgroundGrid) {
  return {
    frame: _objectSpread({
      width: width,
      height: height,
      maxWidth: maxWidth,
      maxHeight: maxHeight,
      display: "flex",
      position: "relative",
      justifyContent: "center",
      alignItems: "center",
      overflow: "hidden"
    }, backgroundGrid)
  };
};
var createSourceStyles = function createSourceStyles(objectFit) {
  return {
    picture: {
      display: "block",
      position: "relative",
      width: "100%",
      height: "100%"
    },
    img: {
      display: "block",
      position: "relative",
      height: "100%",
      width: "100%",
      objectFit: objectFit
    }
  };
};
var createAppStyle = function createAppStyle(resizeMode, width, height, maxWidth, maxHeight) {
  return {
    frame: {
      width: width,
      height: height,
      maxWidth: maxWidth,
      maxHeight: maxHeight
    },
    imageNative: {
      position: "absolute",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      resizeMode: resizeMode
    }
  };
};
// CONCATENATED MODULE: ./node_modules/@soundboks/elements-image/main/index.tsx

var main_jsx = react_default.a.createElement;





var main_createRanges = function createRanges(sourceSet, mediaCondition) {
  return Array.isArray(sourceSet) ? sourceSet.map(function (param) {
    return /*#__PURE__*/react_default.a.createElement("source", {
      srcSet: param.uriSet,
      type: param.type,
      media: mediaCondition,
      key: "".concat(param.uriSet).concat(mediaCondition)
    });
  }) : /*#__PURE__*/react_default.a.createElement("source", {
    srcSet: sourceSet,
    media: mediaCondition,
    key: "".concat(sourceSet)
  });
};

var main_displaySources = function displaySources(uri, objectFit, ranges, alt, sourceTracker) {
  var styles = createSourceStyles(objectFit);
  var defaultImage = /*#__PURE__*/react_default.a.createElement("img", {
    style: styles.img,
    onLoad: sourceTracker,
    alt: alt,
    src: uri
  });

  if (!ranges) {
    return defaultImage;
  }

  return /*#__PURE__*/react_default.a.createElement("picture", {
    style: styles.picture
  }, (ranges === null || ranges === void 0 ? void 0 : ranges.bigDesktop) && main_createRanges(ranges.bigDesktop, MediaConditions.BigDesktop), (ranges === null || ranges === void 0 ? void 0 : ranges.desktop) && main_createRanges(ranges.desktop, MediaConditions.Desktop), (ranges === null || ranges === void 0 ? void 0 : ranges.tabletLandscape) && main_createRanges(ranges.tabletLandscape, MediaConditions.TabletLandscape), (ranges === null || ranges === void 0 ? void 0 : ranges.tabletPortrait) && main_createRanges(ranges.tabletPortrait, MediaConditions.TabletPortrait), (ranges === null || ranges === void 0 ? void 0 : ranges.phone) && main_createRanges(ranges.phone, MediaConditions.Phone), defaultImage);
};

var main_Image = /*#__PURE__*/react_default.a.memo(function Image(_ref) {
  var uri = _ref.uri,
      ranges = _ref.ranges,
      _ref$objectFit = _ref.objectFit,
      objectFit = _ref$objectFit === void 0 ? "cover" : _ref$objectFit,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? "auto" : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? "auto" : _ref$height,
      _ref$maxWidth = _ref.maxWidth,
      maxWidth = _ref$maxWidth === void 0 ? "none" : _ref$maxWidth,
      _ref$maxHeight = _ref.maxHeight,
      maxHeight = _ref$maxHeight === void 0 ? "none" : _ref$maxHeight,
      alt = _ref.alt,
      _ref$showInfo = _ref.showInfo,
      showInfo = _ref$showInfo === void 0 ? false : _ref$showInfo;

  var _useMediaInfo = useMediaInfo(showInfo),
      _useMediaInfo2 = Object(slicedToArray["a" /* default */])(_useMediaInfo, 3),
      sourceTracker = _useMediaInfo2[0],
      displayInfo = _useMediaInfo2[1],
      backgroundGrid = _useMediaInfo2[2];

  var styles = createFrameStyles(width, height, maxWidth, maxHeight, backgroundGrid);
  return /*#__PURE__*/react_default.a.createElement("div", {
    style: styles.frame
  }, main_displaySources(uri, objectFit, ranges, alt, sourceTracker), displayInfo());
});
// CONCATENATED MODULE: ./node_modules/@soundboks/elements-image/main/hosts/butter.ts

var baseUrl = "https://cdn.buttercms.com";
var butter_createUrl = function createUrl(path) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if (!path || path.trim() === "") {
    return "";
  }

  var width = isNum(options.width) ? options.width : 0;
  var height = isNum(options.height) ? options.height : 0;
  var resizeParam = [];

  if (width > 0) {
    resizeParam.push("w:".concat(width));
  }

  if (height > 0) {
    resizeParam.push("h:".concat(height));
  }

  if (width > 0 || height > 0) {
    resizeParam.push("f:crop");
  }

  var url = width > 0 || height > 0 ? new URL("resize=".concat(resizeParam.join(","), "/").concat(path.replace(/^\/+/, "")), baseUrl) : new URL("".concat(path), baseUrl);
  return url.href;
};
var butter_createDensityUrlSet = function createDensityUrlSet(path, options) {
  return withCreateDensityUrlSet(butter_createUrl, path, options);
};
// CONCATENATED MODULE: ./node_modules/@soundboks/elements-image/main/hosts/storyblok.ts

var storyblok_baseUrl = "https://a.storyblok.com";
var baseParamsUrl = "https://img2.storyblok.com";
var storyblok_createUrl = function createUrl(path) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if (!path || path.trim() === "") {
    return "";
  }

  var width = isNum(options.width) ? options.width : 0;
  var height = isNum(options.height) ? options.height : 0;
  var url = width > 0 || height > 0 ? new URL("".concat(width, "x").concat(height, "/").concat(path.replace(/^\/+/, "")), baseParamsUrl) : new URL("".concat(path), storyblok_baseUrl);
  return url.href;
};
var storyblok_createDensityUrlSet = function createDensityUrlSet(path, options) {
  return withCreateDensityUrlSet(storyblok_createUrl, path, options);
};
// CONCATENATED MODULE: ./node_modules/@soundboks/elements-image/main/hosts/imgix.ts

var imgix_baseUrl = "https://soundboks.imgix.net";
var imgix_createUrl = function createUrl(path) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if (!path || path.trim() === "") {
    return "";
  }

  var width = isNum(options.width) ? options.width : 0;
  var height = isNum(options.height) ? options.height : 0;
  var url = new URL(path, imgix_baseUrl);

  if (width > 0) {
    url.searchParams.set("w", width.toString());
  }

  if (height > 0) {
    url.searchParams.set("h", height.toString());
  }

  if (width > 0 || height > 0) {
    url.searchParams.set("fit", "crop");
  }

  url.searchParams.set("auto", "format");
  return url.href;
};
var imgix_createDensityUrlSet = function createDensityUrlSet(path, options) {
  return withCreateDensityUrlSet(imgix_createUrl, path, options);
};
// CONCATENATED MODULE: ./node_modules/@soundboks/elements-image/index.ts






/***/ }),

/***/ "GGAD":
/***/ (function(module, exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/app",
      function () {
        return __webpack_require__("axfi");
      }
    ]);
  

/***/ }),

/***/ "Gg02":
/***/ (function(module, exports) {

module.exports = {"url": "https://soundboks.imgix.net/desktop-hero-372614d20a1520ef976acf91100cd397.png", "placeholder": "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAALCAYAAAB/Ca1DAAAACXBIWXMAAAsTAAALEwEAmpwYAAADEUlEQVQozz2T60+TVxzHTxYTIWqWTej1uT9PSwttVaorKVCLK0itSK2lFkqdo3YmDR2dDRcfsXPMyyLgDYyJxkQNQWPUqImXRKOvfLHMyDtFfbNkb/wT8IGd7x6q8ySfnEt++Z2Tz+93iCjLKCNJkBUZkg7LizAYzKivr0dsVww2m61MZ2dn+ezragEMJ0IUGJhMRpgZHtLnPERkzRA5K3iBhdFkBmMxoaVpHVrC32GgUMC/S0t493Ye8/NvsLDwEYVCHrnObxDaXAfWFUIilcX2kBdmswWCnosITTEYvR3YsVmCmlyN0l4OsfYabI+3YGioiOXx56s5zM29Kq9HBgfwYpzg3lEbTmSbMTGcwZH9G8HUNWN9awKk4fAtnL6QwfRoGHg9gPdPB5Hp2YLB/gQa/A2Ih9vQUV8HucYBv9+PQJMPV07uwfUpFe8fjuOv2QPId7fA4w8hrF4FuXkxin9ejuKXPj9uTPVi6mQ/jqo9KOai4AQOKwiB4SsCQj7BcjyGh0cwdWYSM9eu4u7sZfSletC+pRG9+34CefnsNp4/fqIXQ0FzIAify4I2nxU/pgKw2WVUWcz4Vsfr26RfIOiuTHBtaECwcSM8wipEQwpCrT7sjkYwO10EGcu7kUm40fU9g7MjYRR/aMTYUBDDR1JQFB4VFZU6K+F2u+Fw1oJnTfgj70Uptw2Hsl4cO7EbXboi0VmDRHwTyN+za+j0AYbmexvp/UsF+uT67/TMWI6m4h3U5XLS8YkJTE5OUr2tqMFogl0R6Y1Te+idiwfpo5lf6c/ZbhppC1DWVUuTUQMlHx5I2vE+m+bxbNBi8aTW1b1Xy2RzWjqd1pxO52KpVKKFQoFWVVfTispKyvPcYmt7ROtKprVkep+Wy/VrwWBAC4XbtN8GQxp5dt6CQ30OiKKkNysHjufLs6DvWY79Uoz/YRhr2TfDsmWnVpbXP4WASGQrzo3tBPHUMmpdraJK8jLSJyRpVFaUoixL10xGw6L+qgWr1bJQtXbtkiJLMza7rbgc8zlW1XWo9hq76nA61P8AhpuUlQ3VNH0AAAAASUVORK5CYII="};

/***/ }),

/***/ "axfi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__("q1tI");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./node_modules/@lingui/react/index.js
var _lingui_react = __webpack_require__("ZD0w");

// EXTERNAL MODULE: ./components/wrappers/Layout/index.js + 33 modules
var Layout = __webpack_require__("8hyx");

// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js
var styled_components_browser_esm = __webpack_require__("vOnD");

// EXTERNAL MODULE: ./components/wrappers/PageTracker/index.tsx
var PageTracker = __webpack_require__("LDcx");

// EXTERNAL MODULE: ./node_modules/@soundboks/sb-components/src/styles/theme.ts
var theme = __webpack_require__("isV7");

// EXTERNAL MODULE: ./components/shared/Meta/index.js + 6 modules
var Meta = __webpack_require__("ACIN");

// CONCATENATED MODULE: ./components/pages/app/Meta.js
var __jsx = react_default.a.createElement;



var Meta_Component = function Component() {
  return /*#__PURE__*/react_default.a.createElement(Meta["a" /* default */], {
    pageInfo: {
      title:
      /*i18n*/
      {
        id: "products.soundboksGen3.app.meta.title",
        defaults: "Bluetooth Speaker Control App | SOUNDBOKS App"
      },
      desc:
      /*i18n*/
      {
        id: "products.soundboksGen3.app.meta.description",
        defaults: "The SOUNDBOKS app gives you access to additional controls and upgrades to SOUNDBOKS firmware for enhanced sound, connectivity and more."
      },
      url: '/products/soundboks-gen-3/app/'
    }
  });
};

/* harmony default export */ var app_Meta = (Meta_Component);
// EXTERNAL MODULE: ./styles/theme.js
var styles_theme = __webpack_require__("NVT0");

// EXTERNAL MODULE: ./node_modules/@soundboks/sb-components/src/molecules/Composition/index.ts + 16 modules
var Composition = __webpack_require__("C2Jz");

// EXTERNAL MODULE: ./node_modules/@soundboks/sb-components/src/atoms/Text/index.tsx
var Text = __webpack_require__("Zd2Y");

// EXTERNAL MODULE: ./node_modules/@soundboks/sb-components/src/atoms/Icon/index.tsx + 105 modules
var Icon = __webpack_require__("ZSX1");

// EXTERNAL MODULE: ./node_modules/@soundboks/elements-image/index.ts + 7 modules
var elements_image = __webpack_require__("FYf8");

// CONCATENATED MODULE: ./components/pages/app/configuration/imageSources.js
var imageSources = {};
imageSources.heroPhone = __webpack_require__("vKoW");
imageSources.heroDesktop = __webpack_require__("Gg02");
imageSources.propanel = __webpack_require__("lo1z");
imageSources.drawer = __webpack_require__("vSuU");
imageSources.locked = __webpack_require__("muka");
/* harmony default export */ var configuration_imageSources = (imageSources);
// CONCATENATED MODULE: ./components/pages/app/components/SectionHero.tsx
var SectionHero_jsx = react_default.a.createElement;











var SectionHero_SessionHero = function SessionHero() {
  return /*#__PURE__*/react_default.a.createElement(react_default.a.Fragment, null, /*#__PURE__*/react_default.a.createElement(HeroWrapper, null, /*#__PURE__*/react_default.a.createElement(TextWrapper, null, /*#__PURE__*/react_default.a.createElement(Composition["b" /* Layout */], {
    omitPadding: true,
    direction: Composition["d" /* LayoutDirection */].Column,
    alignX: Composition["c" /* LayoutAlignment */].Center,
    alignY: Composition["c" /* LayoutAlignment */].Start
  }, /*#__PURE__*/react_default.a.createElement(Text["j" /* default */], {
    textAlign: Text["f" /* TextAlign */].Center,
    colorForeground: theme["a" /* Color */].Primary,
    type: Text["i" /* TextType */].Caption,
    textTransform: Text["h" /* TextTransform */].UpperCase
  }, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "product.soundboksGen3.app.hero.header"
  })), /*#__PURE__*/react_default.a.createElement(Composition["e" /* Spacer */], {
    direction: Composition["f" /* SpacerDirection */].Vertical,
    size: theme["l" /* Space */].Smaller
  }), /*#__PURE__*/react_default.a.createElement(Text["j" /* default */], {
    textAlign: Text["f" /* TextAlign */].Center,
    colorForeground: theme["a" /* Color */].White,
    type: Text["i" /* TextType */].Heading,
    textTransform: Text["h" /* TextTransform */].UpperCase
  }, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "product.soundboksGen3.app.hero.subHeader"
  })), /*#__PURE__*/react_default.a.createElement(Composition["e" /* Spacer */], {
    direction: Composition["f" /* SpacerDirection */].Vertical,
    size: theme["l" /* Space */].Medium
  }), /*#__PURE__*/react_default.a.createElement(Text["j" /* default */], {
    textAlign: Text["f" /* TextAlign */].Center,
    colorForeground: theme["a" /* Color */].White,
    type: Text["i" /* TextType */].ParagraphLarge
  }, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "product.soundboksGen3.app.hero.body"
  })), /*#__PURE__*/react_default.a.createElement(Composition["e" /* Spacer */], {
    direction: Composition["f" /* SpacerDirection */].Vertical,
    size: theme["l" /* Space */].Large
  }), /*#__PURE__*/react_default.a.createElement(Composition["b" /* Layout */], {
    omitPadding: true,
    direction: Composition["d" /* LayoutDirection */].Row,
    alignX: Composition["c" /* LayoutAlignment */].Center,
    alignY: Composition["c" /* LayoutAlignment */].Start
  }, /*#__PURE__*/react_default.a.createElement("a", {
    href: "https://play.google.com/store/apps/details?id=com.soundboks.SOUNDBOKS"
  }, /*#__PURE__*/react_default.a.createElement(Icon["b" /* default */], {
    height: styles_theme["a" /* default */].baseline * 5,
    id: Icon["a" /* IconId */].DownloadGooglaPlay
  })), /*#__PURE__*/react_default.a.createElement(Composition["e" /* Spacer */], {
    direction: Composition["f" /* SpacerDirection */].Horizontal,
    size: theme["l" /* Space */].Small
  }), /*#__PURE__*/react_default.a.createElement("a", {
    href: "https://apps.apple.com/us/app/soundboks/id1440156667"
  }, /*#__PURE__*/react_default.a.createElement(Icon["b" /* default */], {
    height: styles_theme["a" /* default */].baseline * 5,
    id: Icon["a" /* IconId */].DownloadAppStore
  })))))), /*#__PURE__*/react_default.a.createElement(Composition["e" /* Spacer */], {
    direction: Composition["f" /* SpacerDirection */].Vertical,
    size: theme["l" /* Space */].MediumLarge
  }), /*#__PURE__*/react_default.a.createElement(ImageWrapper, null, /*#__PURE__*/react_default.a.createElement(elements_image["a" /* Image */], {
    uri: configuration_imageSources.heroPhone.url,
    ranges: {
      phone: configuration_imageSources.heroPhone.url,
      desktop: configuration_imageSources.heroDesktop.url
    },
    objectFit: "contain",
    width: "100vw"
  })));
};

var ImageWrapper = styled_components_browser_esm["default"].div.withConfig({
  displayName: "SectionHero__ImageWrapper",
  componentId: "kgwhv4-0"
})(["background-color:", ";margin-top:-2px;"], theme["a" /* Color */].White);
var HeroWrapper = styled_components_browser_esm["default"].div.withConfig({
  displayName: "SectionHero__HeroWrapper",
  componentId: "kgwhv4-1"
})(["position:relative;display:flex;flex-direction:column;justify-content:space-between;align-items:center;max-width:", "px;margin:0 auto;@media ", "{margin-bottom:0;width:100%;}"], theme["c" /* ContentMaxWidth */].Large, styles_theme["a" /* default */].breakpoints.desktop);
var TextWrapper = styled_components_browser_esm["default"].div.withConfig({
  displayName: "SectionHero__TextWrapper",
  componentId: "kgwhv4-2"
})(["width:100%;padding:", "px 10px 0 10px;@media ", "{max-width:", "px;}@media ", "{padding:", "px 10px 0 10px;width:50%;}"], styles_theme["a" /* default */].baseline * 9, styles_theme["a" /* default */].breakpoints.tablet, theme["c" /* ContentMaxWidth */].Medium, styles_theme["a" /* default */].breakpoints.desktop, styles_theme["a" /* default */].baseline * 16);
/* harmony default export */ var SectionHero = (SectionHero_SessionHero);
// EXTERNAL MODULE: ./components/atoms/Link/index.tsx
var Link = __webpack_require__("ZT91");

// EXTERNAL MODULE: ./components/elements/spacer/index.web.tsx + 1 modules
var index_web = __webpack_require__("n75Q");

// CONCATENATED MODULE: ./components/pages/app/components/Usp/UspContext.tsx

var UspContext = /*#__PURE__*/Object(react["createContext"])(null);
/* harmony default export */ var Usp_UspContext = (UspContext);
// CONCATENATED MODULE: ./components/pages/app/components/Usp/Usps.tsx
var Usps_jsx = react_default.a.createElement;







var Usps_Usps = function Usps(_ref) {
  var colorForeground = _ref.colorForeground,
      colorHeaderForeground = _ref.colorHeaderForeground,
      colorHeaderBackground = _ref.colorHeaderBackground,
      children = _ref.children,
      header = _ref.header;
  return /*#__PURE__*/react_default.a.createElement(Wrapper, null, /*#__PURE__*/react_default.a.createElement(Text["j" /* default */], {
    textAlign: Text["f" /* TextAlign */].Center,
    colorForeground: colorHeaderForeground,
    colorBackground: colorHeaderBackground,
    type: Text["i" /* TextType */].HeadingSmall,
    textTransform: Text["h" /* TextTransform */].UpperCase,
    alignSelf: Text["a" /* AlignSelf */].Center
  }, header), /*#__PURE__*/react_default.a.createElement(Composition["e" /* Spacer */], {
    direction: Composition["f" /* SpacerDirection */].Vertical,
    size: theme["l" /* Space */].Medium
  }), /*#__PURE__*/react_default.a.createElement(Composition["b" /* Layout */], {
    direction: Composition["d" /* LayoutDirection */].Row,
    forceNowrap: true,
    omitPadding: true,
    alignX: Composition["c" /* LayoutAlignment */].Center,
    alignY: Composition["c" /* LayoutAlignment */].Start
  }, /*#__PURE__*/react_default.a.createElement(Usp_UspContext.Provider, {
    value: {
      color: colorForeground
    }
  }, children)));
};

var Wrapper = styled_components_browser_esm["default"].div.withConfig({
  displayName: "Usps__Wrapper",
  componentId: "sc-1pi36xu-0"
})(["display:flex;flex-direction:column;align-items:center;"]);
/* harmony default export */ var Usp_Usps = (Usps_Usps);
// CONCATENATED MODULE: ./components/pages/app/components/Usp/Usp.tsx
var Usp_jsx = react_default.a.createElement;








var Usp_Usp = function Usp(_ref) {
  var text = _ref.text,
      iconId = _ref.iconId;

  var _useContext = Object(react["useContext"])(Usp_UspContext),
      color = _useContext.color;

  return /*#__PURE__*/react_default.a.createElement(Usp_Wrapper, null, /*#__PURE__*/react_default.a.createElement(Icon["b" /* default */], {
    color: color,
    size: theme["d" /* IconSize */].Medium,
    id: iconId
  }), /*#__PURE__*/react_default.a.createElement(Composition["e" /* Spacer */], {
    size: theme["l" /* Space */].Smaller,
    direction: Composition["f" /* SpacerDirection */].Vertical
  }), /*#__PURE__*/react_default.a.createElement(Text["j" /* default */], {
    textAlign: Text["f" /* TextAlign */].Center,
    colorForeground: color,
    type: Text["i" /* TextType */].ParagraphLarge
  }, text));
};

var Usp_Wrapper = styled_components_browser_esm["default"].div.withConfig({
  displayName: "Usp__Wrapper",
  componentId: "hhta2z-0"
})(["display:flex;flex-direction:column;max-width:150px;margin:0 ", "px;"], theme["l" /* Space */].Small);
/* harmony default export */ var components_Usp_Usp = (Usp_Usp);
// EXTERNAL MODULE: ./components/shared/Composition/index.js + 27 modules
var shared_Composition = __webpack_require__("FpTs");

// CONCATENATED MODULE: ./components/pages/app/components/Usp/UspImage.tsx
var UspImage_jsx = react_default.a.createElement;





var UspImage_UspImage = function UspImage(_ref) {
  var sourceSet = _ref.sourceSet;
  return /*#__PURE__*/react_default.a.createElement(StyledImage, {
    sourceSet: sourceSet,
    objectFit: "cover",
    objectPosition: "center center"
  });
};

var StyledImage = Object(styled_components_browser_esm["default"])(shared_Composition["g" /* Image */]).withConfig({
  displayName: "UspImage__StyledImage",
  componentId: "w1zefo-0"
})(["width:90%;height:auto;@media ", "{width:50%;}@media ", "{width:45%;margin:0;}"], styles_theme["a" /* default */].breakpoints.tablet, styles_theme["a" /* default */].breakpoints.desktop);
/* harmony default export */ var Usp_UspImage = (UspImage_UspImage);
// CONCATENATED MODULE: ./components/pages/app/components/Usp/index.ts



// CONCATENATED MODULE: ./components/pages/app/components/ContentWrapper.tsx
var ContentWrapper_jsx = react_default.a.createElement;





var ContentWrapper_ContentWrapper = function ContentWrapper(_ref) {
  var children = _ref.children,
      reverseOrder = _ref.reverseOrder;
  return /*#__PURE__*/react_default.a.createElement(ContentWrapper_Wrapper, {
    reverseOrder: reverseOrder
  }, children);
};

var ContentWrapper_Wrapper = styled_components_browser_esm["default"].div.withConfig({
  displayName: "ContentWrapper__Wrapper",
  componentId: "sc-6a6gkn-0"
})(["position:relative;display:flex;flex-direction:column;justify-content:space-between;align-items:center;max-width:", "px;margin:0 auto;padding:", "px 0;width:80%;& > *{margin-bottom:", "px;}& > *:last-child{margin-bottom:0;}@media ", "{margin-bottom:0;padding:100px 100px;width:100%;flex-direction:", ";}"], theme["c" /* ContentMaxWidth */].Large, styles_theme["a" /* default */].baseline * 9, styles_theme["a" /* default */].baseline * 6, styles_theme["a" /* default */].breakpoints.desktop, function (_ref2) {
  var reverseOrder = _ref2.reverseOrder;
  return reverseOrder ? 'row-reverse' : 'row';
});
/* harmony default export */ var components_ContentWrapper = (ContentWrapper_ContentWrapper);
// CONCATENATED MODULE: ./components/pages/app/components/SectionDirektAccess.tsx
var SectionDirektAccess_jsx = react_default.a.createElement;












var SectionDirektAccess_SectionDirektAccess = function SectionDirektAccess() {
  return /*#__PURE__*/react_default.a.createElement(Composition["g" /* default */], null, /*#__PURE__*/react_default.a.createElement(Composition["a" /* BackgroundColor */], {
    color: theme["a" /* Color */].White
  }), /*#__PURE__*/react_default.a.createElement(index_web["a" /* Spacer */], {
    height: {
      "default": '10px',
      desktop: '50px'
    }
  }), /*#__PURE__*/react_default.a.createElement(components_ContentWrapper, null, /*#__PURE__*/react_default.a.createElement(Usp_UspImage, {
    sourceSet: {
      mobile: configuration_imageSources.propanel.url,
      placeholder: configuration_imageSources.propanel.placeholder
    }
  }), /*#__PURE__*/react_default.a.createElement(Usp_Usps, {
    colorForeground: theme["a" /* Color */].Charcoal,
    colorHeaderBackground: theme["a" /* Color */].Charcoal,
    colorHeaderForeground: theme["a" /* Color */].White,
    header: /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
      id: "product.soundboksGen3.app.uspDirektAccess.header"
    })
  }, /*#__PURE__*/react_default.a.createElement(components_Usp_Usp, {
    iconId: Icon["a" /* IconId */].SettingsApp,
    text:
    /*#__PURE__*/

    /* eslint-disable jsx-a11y/anchor-has-content, jsx-a11y/control-has-associated-label */
    react_default.a.createElement(_lingui_react["Trans"], {
      id: "product.soundboksGen3.app.uspDirektAccess.usp1"
    })
  }), /*#__PURE__*/react_default.a.createElement(components_Usp_Usp, {
    iconId: Icon["a" /* IconId */].TeamUp,
    text: /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
      id: "product.soundboksGen3.app.uspDirektAccess.usp2",
      components: [/*#__PURE__*/react_default.a.createElement("br", null), /*#__PURE__*/react_default.a.createElement(SectionDirektAccess_LinkWrapper, {
        href: "/direkt"
      })]
    })
  }))));
};

var Anchor = styled_components_browser_esm["default"].a.withConfig({
  displayName: "SectionDirektAccess__Anchor",
  componentId: "sc-13qwjp8-0"
})(["color:", ";cursor:pointer;"], theme["a" /* Color */].Primary);

var SectionDirektAccess_LinkWrapper = function LinkWrapper(_ref) {
  var href = _ref.href,
      _ref$children = _ref.children,
      children = _ref$children === void 0 ? undefined : _ref$children;
  return /*#__PURE__*/react_default.a.createElement(Link["a" /* default */], {
    href: href,
    prefetch: false
  }, /*#__PURE__*/react_default.a.createElement(Anchor, null, children));
};

/* harmony default export */ var components_SectionDirektAccess = (SectionDirektAccess_SectionDirektAccess);
// CONCATENATED MODULE: ./components/pages/app/components/SectionMoreControl.tsx
var SectionMoreControl_jsx = react_default.a.createElement;









var SectionMoreControl_SectionMoreControl = function SectionMoreControl() {
  return /*#__PURE__*/react_default.a.createElement(Composition["g" /* default */], null, /*#__PURE__*/react_default.a.createElement(Composition["a" /* BackgroundColor */], {
    color: theme["a" /* Color */].Charcoal
  }), /*#__PURE__*/react_default.a.createElement(components_ContentWrapper, {
    reverseOrder: true
  }, /*#__PURE__*/react_default.a.createElement(Usp_UspImage, {
    sourceSet: {
      mobile: configuration_imageSources.drawer.url,
      placeholder: configuration_imageSources.drawer.placeholder
    }
  }), /*#__PURE__*/react_default.a.createElement(Usp_Usps, {
    colorForeground: theme["a" /* Color */].White,
    colorHeaderBackground: theme["a" /* Color */].White,
    colorHeaderForeground: theme["a" /* Color */].Charcoal,
    header: /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
      id: "product.soundboksGen3.app.uspMoreSoundboks.header"
    })
  }, /*#__PURE__*/react_default.a.createElement(components_Usp_Usp, {
    iconId: Icon["a" /* IconId */].Warranty,
    text:
    /*#__PURE__*/

    /* eslint-disable jsx-a11y/anchor-has-content, jsx-a11y/control-has-associated-label */
    react_default.a.createElement(_lingui_react["Trans"], {
      id: "product.soundboksGen3.app.uspMoreSoundboks.usp1",
      components: [/*#__PURE__*/react_default.a.createElement("a", {
        href: "https://soundboks.zendesk.com/hc/en-gb/articles/360018225519-APP-LEVELUP2-SOUNDKLUB-BENEFITS"
      })]
    })
  }), /*#__PURE__*/react_default.a.createElement(components_Usp_Usp, {
    iconId: Icon["a" /* IconId */].Locked,
    text: /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
      id: "product.soundboksGen3.app.uspMoreSoundboks.usp2"
    })
  }))));
};

/* harmony default export */ var components_SectionMoreControl = (SectionMoreControl_SectionMoreControl);
// CONCATENATED MODULE: ./components/pages/app/components/SectionMoreSoundboks.tsx
var SectionMoreSoundboks_jsx = react_default.a.createElement;









var SectionMoreSoundboks_SectionMoreSoundboks = function SectionMoreSoundboks() {
  return /*#__PURE__*/react_default.a.createElement(Composition["g" /* default */], null, /*#__PURE__*/react_default.a.createElement(Composition["a" /* BackgroundColor */], {
    color: theme["a" /* Color */].White
  }), /*#__PURE__*/react_default.a.createElement(components_ContentWrapper, null, /*#__PURE__*/react_default.a.createElement(Usp_UspImage, {
    sourceSet: {
      mobile: configuration_imageSources.locked.url,
      placeholder: configuration_imageSources.locked.placeholder
    }
  }), /*#__PURE__*/react_default.a.createElement(Usp_Usps, {
    colorForeground: theme["a" /* Color */].Charcoal,
    colorHeaderBackground: theme["a" /* Color */].Charcoal,
    colorHeaderForeground: theme["a" /* Color */].White,
    header: /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
      id: "product.soundboksGen3.app.uspMoreControl.header"
    })
  }, /*#__PURE__*/react_default.a.createElement(components_Usp_Usp, {
    iconId: Icon["a" /* IconId */].Skaa,
    text: /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
      id: "product.soundboksGen3.app.uspMoreControl.usp1"
    })
  }), /*#__PURE__*/react_default.a.createElement(components_Usp_Usp, {
    iconId: Icon["a" /* IconId */].Mic,
    text:
    /*#__PURE__*/

    /* eslint-disable jsx-a11y/anchor-has-content, jsx-a11y/control-has-associated-label */
    react_default.a.createElement(_lingui_react["Trans"], {
      id: "product.soundboksGen3.app.uspMoreControl.usp2"
    })
  }))));
};

/* harmony default export */ var components_SectionMoreSoundboks = (SectionMoreSoundboks_SectionMoreSoundboks);
// CONCATENATED MODULE: ./components/pages/app/index.js
var app_jsx = react_default.a.createElement;










var app_App = function App() {
  return /*#__PURE__*/react_default.a.createElement(PageTracker["a" /* default */], null, /*#__PURE__*/react_default.a.createElement(Container, null, /*#__PURE__*/react_default.a.createElement(app_Meta, null), /*#__PURE__*/react_default.a.createElement(SectionHero, null), /*#__PURE__*/react_default.a.createElement(components_SectionDirektAccess, null), /*#__PURE__*/react_default.a.createElement(components_SectionMoreControl, null), /*#__PURE__*/react_default.a.createElement(components_SectionMoreSoundboks, null)));
};

var Container = styled_components_browser_esm["default"].div.withConfig({
  displayName: "app__Container",
  componentId: "sc-3om0d2-0"
})(["background-color:", ";"], theme["a" /* Color */].Charcoal);
/* harmony default export */ var app = (app_App);
// CONCATENATED MODULE: ./pages/app.tsx
var pages_app_jsx = react_default.a.createElement;





var pages_app_App = function App() {
  return /*#__PURE__*/react_default.a.createElement(react_default.a.Fragment, null, /*#__PURE__*/react_default.a.createElement(Layout["a" /* default */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["I18n"], null, function (_ref) {
    var i18n = _ref.i18n;
    return /*#__PURE__*/react_default.a.createElement(app, null);
  })));
};

/* harmony default export */ var pages_app = __webpack_exports__["default"] = (pages_app_App);

/***/ }),

/***/ "lo1z":
/***/ (function(module, exports) {

module.exports = {"url": "https://soundboks.imgix.net/EQ-96c5ee52f43fccd1a084e7cb7758d02c.png", "placeholder": "data:image/png;base64,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"};

/***/ }),

/***/ "muka":
/***/ (function(module, exports) {

module.exports = {"url": "https://soundboks.imgix.net/propanel-b47ec951d24297993b2a547ad7ab6d46.png", "placeholder": "data:image/png;base64,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"};

/***/ }),

/***/ "n75Q":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ index_web_Spacer; });

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__("q1tI");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js
var styled_components_browser_esm = __webpack_require__("vOnD");

// EXTERNAL MODULE: ./styles/theme.js
var theme = __webpack_require__("NVT0");

// CONCATENATED MODULE: ./components/elements/spacer/styled.ts


var SpacerElement = styled_components_browser_esm["default"].div.withConfig({
  displayName: "styled__SpacerElement",
  componentId: "nc7ihq-0"
})(["", " ", " @media ", "{", " ", "}@media ", "{", " ", "}@media ", "{", " ", "}@media ", "{", " ", "}"], function (_ref) {
  var mediaQueryWidth = _ref.mediaQueryWidth;
  return mediaQueryWidth !== undefined && "width: ".concat(mediaQueryWidth["default"], ";");
}, function (_ref2) {
  var mediaQueryHeight = _ref2.mediaQueryHeight;
  return mediaQueryHeight !== undefined && "height: ".concat(mediaQueryHeight["default"], ";");
}, theme["a" /* default */].breakpoints.maxMobile, function (_ref3) {
  var mediaQueryWidth = _ref3.mediaQueryWidth;
  return (mediaQueryWidth === null || mediaQueryWidth === void 0 ? void 0 : mediaQueryWidth.mobile) !== undefined && "width: ".concat(mediaQueryWidth.mobile, ";");
}, function (_ref4) {
  var mediaQueryHeight = _ref4.mediaQueryHeight;
  return (mediaQueryHeight === null || mediaQueryHeight === void 0 ? void 0 : mediaQueryHeight.mobile) !== undefined && "height: ".concat(mediaQueryHeight.mobile, ";");
}, theme["a" /* default */].breakpoints.tablet, function (_ref5) {
  var mediaQueryWidth = _ref5.mediaQueryWidth;
  return (mediaQueryWidth === null || mediaQueryWidth === void 0 ? void 0 : mediaQueryWidth.tablet) !== undefined && "width: ".concat(mediaQueryWidth.tablet, ";");
}, function (_ref6) {
  var mediaQueryHeight = _ref6.mediaQueryHeight;
  return (mediaQueryHeight === null || mediaQueryHeight === void 0 ? void 0 : mediaQueryHeight.tablet) !== undefined && "height: ".concat(mediaQueryHeight.tablet, ";");
}, theme["a" /* default */].breakpoints.desktop, function (_ref7) {
  var mediaQueryWidth = _ref7.mediaQueryWidth;
  return (mediaQueryWidth === null || mediaQueryWidth === void 0 ? void 0 : mediaQueryWidth.desktop) !== undefined && "width: ".concat(mediaQueryWidth.desktop, ";");
}, function (_ref8) {
  var mediaQueryHeight = _ref8.mediaQueryHeight;
  return (mediaQueryHeight === null || mediaQueryHeight === void 0 ? void 0 : mediaQueryHeight.desktop) !== undefined && "height: ".concat(mediaQueryHeight.desktop, ";");
}, theme["a" /* default */].breakpoints.desktopLarge, function (_ref9) {
  var mediaQueryWidth = _ref9.mediaQueryWidth;
  return (mediaQueryWidth === null || mediaQueryWidth === void 0 ? void 0 : mediaQueryWidth.desktopLarge) !== undefined && "width: ".concat(mediaQueryWidth.desktopLarge, ";");
}, function (_ref10) {
  var mediaQueryHeight = _ref10.mediaQueryHeight;
  return (mediaQueryHeight === null || mediaQueryHeight === void 0 ? void 0 : mediaQueryHeight.desktopLarge) !== undefined && "height: ".concat(mediaQueryHeight.desktopLarge, ";");
});
// CONCATENATED MODULE: ./components/elements/spacer/index.web.tsx
var __jsx = react_default.a.createElement;

 // eslint-disable-next-line prefer-arrow-callback

var index_web_Spacer = /*#__PURE__*/react_default.a.memo(function Spacer(_ref) {
  var width = _ref.width,
      height = _ref.height;
  var mediaQueryHeight = typeof height === 'string' ? {
    "default": height
  } : height;
  var mediaQueryWidth = typeof width === 'string' ? {
    "default": width
  } : width;
  return /*#__PURE__*/react_default.a.createElement(SpacerElement, {
    mediaQueryWidth: mediaQueryWidth,
    mediaQueryHeight: mediaQueryHeight
  });
});

/***/ }),

/***/ "vKoW":
/***/ (function(module, exports) {

module.exports = {"url": "https://soundboks.imgix.net/mobile-hero-730dd32cf04db48869dd7c0631f1ba85.png", "placeholder": "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAARCAYAAADdRIy+AAAACXBIWXMAAAsTAAALEwEAmpwYAAAESElEQVQ4y3WUa0yTVxjHjzgEIe2cQG/09pa2FFpoy6XlYsdd5CJuTuewOnRi1DocmxPdJoM4ENC5W+aIfkBxmk4lDDN0g+G2zOyS7JIs26fpR+NuifF7I7+ddl74sjf55zk57/P/v8/7PP9zhFWxcR8WqxXFFo8KBYUFtLQ0Y7fnYDRmYzIZE+v4Xvzd/VzFptyLcQ0F4bArMtGGPUfBmZuLLScHjVbD0SMj3L59m9HRUfr6+ujv7+f48ePcunWLgYFD6HS6RK4iC7FJUZvNKmFDKEYtDvNyQkU2Njz1OAeGOiiuCPDh+Dj/94yNR1lVpubKoJYzrxoRpiZ8Favp3Pc+4pnqFDrbzPTuyCVUqrBhSyO+EjcTFy8+ELh8eZrp6ekFgufZUKvinwk1f1xQM7i7huj+Sl7p3oH4e9rFzU/DdK7zkue20LX7WTz5Dnp7e5mZmeHM+Qts37mLSCTCxYkJrs59zss9B1lXo5UVZrA37OL7dxqY7SvncNiN+PPHw/z82TDD/bvo3trA6MhuWltqyMzIQCxK4sllAvNigRAPsVy+29Lextz5tzg80M/sJ5f4/etJ/vptEnH1wj6mxns49d52jh3axLGBDlqbKzEZTaSrVJRnpqFNXZwQT05+JCFoMOiob2ySg3uTK5eifPPlFb79apZfvvsC0VTnY01TgNWNJbSsDNJcF8TvdaPT6xCLFyGWLEGkSCRL0ZTkhKBOp8Xr8xEMllIbClJTtYKG6gqqVwQR7WtXErCns8q3jLbgY2xt99HYWIZen43ZYsFsMkkPmqiqrqa1tRWNRoNNscoP6nH7Ktm2tYNyl4qVXjVrgo8iDnatJ1SSR2RTESdObuPjuSHWh2vRZOkwSjMbjUa0Wi0+v59QKITdYZf7CpXFOskJ8HZ/hPoVfja2eTl29AnEQKSCmZOb+SEapqU1SH1dgEK/U/bJQHp6ujS5ljQZs7Ky/jsNFjOZWhMdzXZ+GnXx7t5KTg+t5dfJHTy3OYD46OQws9EjRE+8wZ7Odg5EwqxprsXr9Sa8d+3aNSakXex2O4bs7MQJ0er0su9VRD94jXMnRpg5N8Lk2DAHX+xE7Hmhm+e799PzyusMDQ7S03OAsvJy/H4fU1NTzM3NcfbsWazy7GbJ/mVkZpKdbSAQKCa88Wm6urokv4eXpDcHBwYRLo83VuAvjvlLy2Le4kCswFcUc3s8MUmaj/+unOr8Ag8m1nq9bj7XlRdzSLg8hTGPtyjmLwkmICxWOUnZF7PZJGFOTNTucGCUVahUqrtpaWnz94Tmk5KS4vGuwaDH6XQmXBDnWxJ8yZUaQrHlnJK3xgPIq2vM4/Gc1mk1d+LVqNVqUlNTWbp0KUtSUhKV6nXaO26P+7S8wsYUyVEW8IXVZnsIRREOp1Po9XrRUFe9053vulngyb9eFiy9URYM3CgscF/Pz8u9WV9XtTOeE8+NcxZq/AvEP2ZSBZ3CFQAAAABJRU5ErkJggg=="};

/***/ }),

/***/ "vSuU":
/***/ (function(module, exports) {

module.exports = {"url": "https://soundboks.imgix.net/locked-ecc878815da2bcda5853cef8a7297809.png", "placeholder": "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAApCAYAAAA1bQl+AAAACXBIWXMAAAsTAAALEwEAmpwYAAAEZUlEQVRIx71WS0xbRxR9tjF/YxtqEgoYittIFLtV2q6KBOkCZdMukkhJVGUV0k0XXVRNpaZVpbhSwlfiI5CqbqKu2pSfZCJiWJBEavmzgAZYBFHBpojYRfye37zP6Z1nGzlgbOxKvfLRnZk398x5M3fusyCQLS8vl4VCoZuyLN/a2dlp3N3dvXUaKIrSyBhrBPDZ5ubmOfKCEAwGP9U0bZY8NjY2wI36ScFtbW0Nq6urmJqaQiAQ+GthYcEubG9v36MJO6QQpE6meUoi0NxDT7GKKIrcaxJj8uLi4jtc4V161QDCpmoRCws9btFx7mMAVVUPpqen3ZzQS3sRjLyqeppXPjJHHyAOcWZmxhOXMBVLSniaAzmCQ8LZ2dkwIe1hMPIwLUIiO06YrkIeRvEgiHNzc/EJU9g/3XGFCQnjnOSJp3wqwpjVEylLXSG/PXt7e9jf39dB9xeSJKWvcHJyEv7RUYyNjWH40SP4fD78+fx5eoR0lfDk6VP81teHvv5+DA4OYmBgAPPz8+kTjo+Pwzc8jJHHjzEyMoKhoSFQrqVOGCVdWVnBMBFyZf2k0u/3Y319PRVCkkU/TVV0cHvw049ovn8P7W1teEKKdfWUyIjOidyU44R8RV6+YmpSvEpxrG5xha/clEDAK4dCukLlmU9lty9D/v4G2NdXwL65Rrgaxh1q37kOdvsS2FeXdC99+QmU5Tm94spMihK+9MrigU4oP7ivShfPgF1+C+ziWbAb58GunAP72Al23Q129W1IHwiQzhPeExDyCGDPfGFCKRSjkElhhRsvVGn4Z0ijv4bh/yWCmDYfH3tI/iFC1Fde/h0mlNnxPTxh25LWCOXkaqOq9JTnwSkhJzjl/1AP/z/CVPcwbsXe2tryUpkK8rJEXuUlK0Vo9LHnZU2k77JHILleWiUthTGXh5u4tLTkEbq7u729vb3Brq4udHR0qK2trWijexv1LS0taG9v19HU1KSPczQ3N+tjFK91dnaip6dHJHj4ny8vIUigv06CarPZYbVaYbfZYLVYUGi3o7y8HBUVFSgrK0NRURHsNFZaWors7Gweo0ViRYJHMJlMXkLQYDAgJydH5YHOyjfwOuFseQUqq1yorq5GTU0N3G43XC4Xqqqq9HZJSYlOmJGRAeIQyXsEIjpUSKuqRQ4Hn4S7lZloc2UhM7x6IhwqJNJXCRsaGtQPL3yEymwjXtS9hvULDrxvNeuBJnoDwxEkJbTZ7WpBQYE+8WZpNr5w5iRTl5jQYrGoeXl5MFH7TJYRpYQckyF9Qn7KNKiVO51JldEBIjc3V4tH+EMMoVxcXKzQqSr5+fkK9U8EpY5SWFjI23KE9IAI3+V5+C3hn+jKRAQb5WBWVhZPBfCUOAp+IGazWUeMatVoNL7JFVZS53PCDOF3wh+ECSKbqK2tnaivr5+oq6s7BO/TghN8TgQ8ZpbwnRBrDofDSPuSSYlt9ng8mbQ/lIKCOYLMGK+DctZMMWYeQzcrI8rzL2mpajCL+jonAAAAAElFTkSuQmCC"};

/***/ })

},[["GGAD",0,1,2,3,4,5,6,7,8,10,12]]]);